import React from "react";
import Icon from "@ant-design/icons";

const UnstarIconSvg = ({ width = 14, height = 14 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 14 14"
        >
            <path
                fill="#FEC84B"
                d="M0.853561 0.146454C0.658301 -0.0488125 0.341714 -0.0488192 0.146454 0.146441C-0.0488125 0.341701 -0.0488192 0.658287 0.146441 0.853547L3.34937 4.05654L0.772868 4.43093C0.0346675 4.53819 -0.260086 5.4454 0.274074 5.96607L2.81757 8.44533L2.21713 11.9461C2.09103 12.6814 2.86272 13.2421 3.52299 12.8949L6.66693 11.2421L9.81087 12.8949C10.4711 13.2421 11.2428 12.6814 11.1167 11.9461L11.0914 11.7987L12.4796 13.187C12.6749 13.3823 12.9915 13.3823 13.1867 13.187C13.382 12.9917 13.382 12.6751 13.1867 12.4799L0.853561 0.146454ZM13.0597 5.96607L10.5418 8.42047L4.86739 2.74596L5.85987 0.735014C6.19 0.0660942 7.14387 0.0660942 7.474 0.735014L9.04593 3.92016L12.5609 4.43093C13.2991 4.53819 13.5939 5.44533 13.0597 5.96607Z"
            ></path>
        </svg>
    );
};

const UnstarIcon = ({ width = 14, height = 14, ...props }) => {
    return (
        <Icon
            component={() => <UnstarIconSvg width={width} height={height} />}
            {...props}
        />
    );
};

export default UnstarIcon;